import { render } from "./UserAnalyticsPage.vue?vue&type=template&id=67be2686"
import script from "./UserAnalyticsPage.vue?vue&type=script&lang=js"
export * from "./UserAnalyticsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__